import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../../utils/index.js";
import { PlainButton } from "../PlainButton/index.js";
import { ReviewBadge } from "../ReviewBadge/index.js";
import { P } from "../Text/P.js";
import { reviewScoreVariants } from "./ReviewScore.variants.js";
function ReviewScore({ rating, verbiage, reviewCount, reviewLabel, data, truncateData, onClick, className, emphasis = 'regular', size = 'md' }) {
    const { rootSlot, badgeSlot, contentSlot, verbiageSlot, reviewLineSlot, reviewTextSlot, separatorSlot, dataSlot } = reviewScoreVariants({
        emphasis,
        size,
        truncateData
    });
    const hasReviewCount = Boolean(reviewCount);
    const hasReviewLine = hasReviewCount || Boolean(data);
    const hasContent = Boolean(verbiage) || hasReviewLine;
    const reviewText = [
        reviewCount,
        reviewLabel
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ jsxs("div", {
        className: cn(rootSlot(), className),
        children: [
            /*#__PURE__*/ jsx(ReviewBadge, {
                rating: rating,
                size: size,
                className: badgeSlot()
            }),
            hasContent && /*#__PURE__*/ jsxs("div", {
                className: contentSlot(),
                children: [
                    verbiage && /*#__PURE__*/ jsx(P, {
                        className: verbiageSlot(),
                        children: verbiage
                    }),
                    hasReviewLine && /*#__PURE__*/ jsxs("div", {
                        className: reviewLineSlot(),
                        children: [
                            hasReviewCount && (onClick ? /*#__PURE__*/ jsx(PlainButton, {
                                onClick: onClick,
                                textStyle: "body3",
                                type: "primary",
                                emphasis: emphasis,
                                variant: 'bold' === emphasis ? 'inline' : 'standalone',
                                className: "shrink-0 whitespace-nowrap",
                                children: reviewText
                            }) : /*#__PURE__*/ jsx(P, {
                                className: reviewTextSlot(),
                                children: reviewText
                            })),
                            hasReviewCount && data && /*#__PURE__*/ jsx(P, {
                                className: separatorSlot(),
                                children: "\xb7"
                            }),
                            data && /*#__PURE__*/ jsx(P, {
                                className: dataSlot(),
                                children: data
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export { ReviewScore };
